import { render, staticRenderFns } from "./NotificationPermissionNotification.vue?vue&type=template&id=7500358f&lang=pug&"
import script from "./NotificationPermissionNotification.vue?vue&type=script&lang=js&"
export * from "./NotificationPermissionNotification.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPermissionNotification.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports